import { GetAccountQuery } from "types/graphql-schema";

import Heading from "@components/heading/heading";

import AiMemory from "../ai-memory/ai-memory";
import AiPreferencesSection from "../skills/ai-preferences-section";

const AiPreferencesPage = ({ me }: { me: GetAccountQuery["me"] }) => (
  <div aria-label="AI preferences page">
    <div className="mb-6">
      <Heading small title="Preferences" />
    </div>
    <AiPreferencesSection me={me} />
    {waffle.flag_is_active("ask-ai-memory") && <AiMemory />}
  </div>
);

export default AiPreferencesPage;
